export * from '@fhs/routing/src/routes/(tabs)/rewards/details';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/details';
